exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svgIcon___svg-icon___1BxlF polygon,\n.svgIcon___svg-icon___1BxlF path {\n    fill: currentColor;\n}", ""]);

// exports
exports.locals = {
	"svg-icon": "svgIcon___svg-icon___1BxlF",
	"svgIcon": "svgIcon___svg-icon___1BxlF"
};